module.exports = __webpack_public_path__ + "static/media/Manual_sencer_EN-10.9030dbef.png";